import React from 'react';
import { Pagination, Select } from 'antd';
import { DoubleLeftOutlined, DoubleRightOutlined } from '@ant-design/icons';

import './styles.css';

export type TablePaginationProps = {
    current: number;
    pageSize: number;
    pageCount: number;
    total: number;
    onChange: (page: number, pageSize: number) => void;
};

const PAGE_SIZE_OPTIONS = [10, 25, 50, 100];

const TablePagination = ({ current, pageSize, pageCount, total, onChange }: TablePaginationProps) => {
    const isFirst = current <= 1;
    const isLast = current >= pageCount;

    const itemRender = (_: number, type: string, originalElement: React.ReactNode) => {
        if (type === 'prev') {
            return (
                <span className="tp-btn-group">
                    <span
                        className={`tp-nav-btn${isFirst ? ' tp-nav-btn--disabled' : ''}`}
                        title="First page"
                        onClick={(e) => {
                            if (isFirst) return;
                            e.stopPropagation();
                            onChange(1, pageSize);
                        }}
                    >
                        <DoubleLeftOutlined />
                    </span>
                    {originalElement}
                </span>
            );
        }
        if (type === 'next') {
            return (
                <span className="tp-btn-group">
                    {originalElement}
                    <span
                        className={`tp-nav-btn${isLast ? ' tp-nav-btn--disabled' : ''}`}
                        title="Last page"
                        onClick={(e) => {
                            if (isLast) return;
                            e.stopPropagation();
                            onChange(pageCount, pageSize);
                        }}
                    >
                        <DoubleRightOutlined />
                    </span>
                </span>
            );
        }
        return originalElement;
    };

    return (
        <div className="tp-root">
            <Pagination
                current={current}
                pageSize={pageSize}
                total={total}
                showSizeChanger={false}
                onChange={onChange}
                itemRender={itemRender}
            />
            <Select
                size="small"
                value={pageSize}
                onChange={(size) => onChange(1, size)}
                options={PAGE_SIZE_OPTIONS.map((n) => ({ label: `${n}`, value: n }))}
                className="tp-page-size-select"
                popupMatchSelectWidth={false}
            />
        </div>
    );
};

export default TablePagination;
